"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Squarelate = void 0;
var Builder_1 = require("./Builder");
var jquery_1 = __importDefault(require("jquery"));
var Squarelate;
(function (Squarelate) {
    Squarelate.builder = function () {
        return new Builder_1.Builder();
    };
    Squarelate.defaultBuilder = function (baseUrl, sourceLang) {
        var storageKey = "squarelate-lang";
        return new Builder_1.Builder()
            .imageTranslation(function (lang, filename) { return baseUrl + "/" + lang + "/images/" + filename; }, function (lang, callback) { return jquery_1["default"].getJSON(baseUrl + "/" + lang + "/images/list.json", callback); })
            .linkTranslation(function (lang, filename) { return baseUrl + "/" + lang + "/assets/" + filename; }, function (lang, callback) { return jquery_1["default"].getJSON(baseUrl + "/" + lang + "/assets/list.json", callback); }, function (url) { return url.startsWith('/s/') ? url.substring(3) : null; })
            .textTranslation(function (lang, callback) { return jquery_1["default"].getJSON(baseUrl + "/" + lang + "/dict.json", callback); }, 'p, :header, span, a, b, i, strong, em')
            .useCookie(storageKey)
            .langInUrl(false)
            .sourceLang(sourceLang);
    };
})(Squarelate = exports.Squarelate || (exports.Squarelate = {}));
//# sourceMappingURL=Squarelate.js.map